import { MoreHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { AdminUser } from "@/queries/adminUsers";

interface UserRowActionsProps {
  user: AdminUser;
  isSelf: boolean;
  onViewDetails: () => void;
  onResetPassword: () => void;
  onDeactivate: () => void;
  onDelete: () => void;
}

export function UserRowActions({
  user,
  isSelf,
  onViewDetails,
  onResetPassword,
  onDeactivate,
  onDelete,
}: UserRowActionsProps) {
  const { t } = useTranslation("admin-users");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t("row.openMenu")}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onSelect={onViewDetails}>
          {t("row.viewDetails")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onResetPassword}>
          {t("row.resetPassword")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {user.is_active ? (
          <DropdownMenuItem onSelect={onDeactivate} disabled={isSelf}>
            {t("row.deactivate")}
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuItem
          variant="destructive"
          onSelect={onDelete}
          disabled={isSelf}
        >
          {t("row.delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
